import { render, staticRenderFns } from "./TableMedicalVisit.vue?vue&type=template&id=4bd73601&"
import script from "./TableMedicalVisit.vue?vue&type=script&lang=js&"
export * from "./TableMedicalVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports